import { ApiArrayGetter } from "@/services/api/apiService";
import { enhanceObjectCopy } from "@/helpers/units";

export class LabsResearchResult {
  "srv_text": string | null = null;
  "dist": string | null = null;
  "measur": string | null = null;
  "unit": string | null = null;
  "result": string | null = null;
  "norm": string | null = null;
  "text": string | null = null;
  "notes": string | null = null;
  "test_notes": string | null = null;
  "headermark":  string | null = null;
  "norm_text": string | null = null;
  "id": number | null = null;
  "seqno": number | null = null;
  "resultdate": string | null = null;
  "specimen_text": string | null = null;
  "regdate": string | null = null;


  constructor(rawData: Record<string, unknown> = {}) {
    enhanceObjectCopy(rawData, this as Record<string, unknown>);
  }
}
interface IAPILabsResearchResultParams {
  /**
   * unique id for research lab result(передавая его, мы получим информацию о неруторовом исследовании rchild)
   */
  researchid?: string;
  /**
   * child researchId, передается в параметре вместе с типом лаборатории
   */
  rchild: string;
  /**
   * type of laboratory - internal("int") or external("ext"), передается в параметре вместе с rchild, пример пути /labs/research/441074554162/ext
   */
  type: 'int' | 'ext';
}

export const API_Labs_research_result = (params: IAPILabsResearchResultParams): Promise<LabsResearchResult[]> => {
  let reqEnd = "";
  if (params.rchild) reqEnd += params.rchild + '/';
  if (params.type) reqEnd += params.type + '';

  return ApiArrayGetter<
    Record<string, unknown>,
    LabsResearchResult
    >(
    {
      endpoint: `/labs/research/${reqEnd}`,
      method: "get",
    },
    LabsResearchResult
  )({});
}
  /*
  return new Promise<LabsResearchResult>((resolve, reject) => {
    apiService
      .send({
        endpoint: `/labs/research/${reqEnd}`,
        method: "get",
        data: {
          researchid: params.researchid,
        },
      })
      .then((response) => {
        if (response) {
          const obj = new LabsResearchResult(response);

          resolve(obj);
          return;
        }
        reject("response data in not an obj!");
      })
      .catch((err) => {
        reject(err);
      });
  });
};
*/
